import { render, staticRenderFns } from "./homeTab.vue?vue&type=template&id=f5684a92&scoped=true"
import script from "./homeTab.vue?vue&type=script&lang=ts"
export * from "./homeTab.vue?vue&type=script&lang=ts"
import style0 from "./homeTab.vue?vue&type=style&index=0&id=f5684a92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5684a92",
  null
  
)

export default component.exports